/* Rollo — scroll motion, bundle helpers and storefront micro-interactions.
   Plain script (no modules) so it runs independently of Horizon's bundles. */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.RolloReady = true;

  /* ------------------------------------------------------------ reveal ---- */
  var revealObserver = null;

  function setupReveal(scope) {
    var items = scope.querySelectorAll('[data-r]:not([data-r-ready])');
    if (!items.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.setAttribute('data-r-ready', '');
        el.classList.add('r-in');
      });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('r-in');
            revealObserver.unobserve(entry.target);
            countUp(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );
    }

    items.forEach(function (el) {
      el.setAttribute('data-r-ready', '');
      revealObserver.observe(el);
    });

    scope.querySelectorAll('[data-r-stagger]:not([data-r-stagger-ready])').forEach(function (parent) {
      parent.setAttribute('data-r-stagger-ready', '');
      var step = parseInt(parent.getAttribute('data-r-stagger'), 10) || 90;
      Array.prototype.forEach.call(parent.children, function (child, i) {
        child.style.setProperty('--r-delay', i * step);
      });
    });
  }

  /* ------------------------------------------------ scroll-linked progress - */
  var progressItems = [];
  var ticking = false;

  function setupProgress(scope) {
    scope.querySelectorAll('[data-r-progress]:not([data-r-progress-ready])').forEach(function (el) {
      el.setAttribute('data-r-progress-ready', '');
      var item = { el: el, mode: el.getAttribute('data-r-progress') || 'enter', trail: null };
      var svgPath = el.querySelector('.r-trail__draw');
      if (svgPath && svgPath.getTotalLength) {
        var len = svgPath.getTotalLength();
        el.style.setProperty('--r-len', len);
        item.trail = { path: svgPath, len: len, ball: el.querySelector('.r-trail__ball') };
      }
      progressItems.push(item);
    });
    if (progressItems.length && !reduce) {
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      requestUpdate();
    }
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateProgress);
  }

  function updateProgress() {
    ticking = false;
    var vh = window.innerHeight || 1;
    progressItems.forEach(function (item) {
      var rect = item.el.getBoundingClientRect();
      if (rect.bottom < -vh || rect.top > vh * 2) return;
      var p;
      if (item.mode === 'pass') {
        p = (vh - rect.top) / (vh + rect.height);
      } else {
        p = (vh * 0.88 - rect.top) / Math.max(rect.height * 0.7, vh * 0.35);
      }
      p = Math.min(1, Math.max(0, p));
      item.el.style.setProperty('--r-p', p.toFixed(4));

      if (item.trail && item.trail.ball) {
        var point = item.trail.path.getPointAtLength(item.trail.len * p);
        item.trail.ball.setAttribute(
          'transform',
          'translate(' + point.x.toFixed(2) + ' ' + point.y.toFixed(2) + ') rotate(' + (p * 1440).toFixed(1) + ')'
        );
      }
    });
  }

  /* -------------------------------------------------------------- counters - */
  function countUp(el) {
    var target = el.matches('[data-r-count]') ? el : el.querySelector('[data-r-count]');
    if (!target || target.hasAttribute('data-r-counted')) return;
    target.setAttribute('data-r-counted', '');
    var to = parseFloat(target.textContent.replace(/[^\d.]/g, ''));
    if (isNaN(to) || reduce) return;
    var prefix = target.textContent.split(/[\d.]+/)[0] || '';
    var suffix = target.textContent.replace(prefix, '').replace(/^[\d.]+/, '');
    var decimals = (String(to).split('.')[1] || '').length;
    var start = performance.now();
    var dur = 900;
    (function step(now) {
      var t = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      target.textContent = prefix + (to * eased).toFixed(decimals) + suffix;
      if (t < 1) requestAnimationFrame(step);
    })(start);
  }

  /* ------------------------------------------------------------------ faq -- */
  function setupFaq(scope) {
    scope.querySelectorAll('.r-faq__item:not([data-r-faq-ready])').forEach(function (item) {
      item.setAttribute('data-r-faq-ready', '');
      var summary = item.querySelector('summary');
      var body = item.querySelector('.r-faq__body');
      if (!summary || !body || reduce || !body.animate) return;

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        var isOpen = item.hasAttribute('open');
        var startHeight = body.offsetHeight;
        if (!isOpen) item.setAttribute('open', '');
        var endHeight = isOpen ? 0 : body.scrollHeight;
        if (!isOpen) body.style.height = '0px';

        var animation = body.animate(
          { height: [startHeight + 'px', endHeight + 'px'] },
          { duration: 280, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)' }
        );
        animation.onfinish = function () {
          body.style.height = '';
          if (isOpen) item.removeAttribute('open');
        };
      });
    });
  }

  /* ------------------------------------------------------ delivery estimate - */
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  function setupDelivery(scope) {
    scope.querySelectorAll('[data-r-delivery]:not([data-r-delivery-ready])').forEach(function (el) {
      el.setAttribute('data-r-delivery-ready', '');
      var out = el.querySelector('[data-r-delivery-range]');
      if (!out) return;
      var procMin = parseInt(el.getAttribute('data-processing-min'), 10);
      var procMax = parseInt(el.getAttribute('data-processing-max'), 10);
      var shipMin = parseInt(el.getAttribute('data-shipping-min'), 10);
      var shipMax = parseInt(el.getAttribute('data-shipping-max'), 10);
      if ([procMin, procMax, shipMin, shipMax].some(isNaN)) return;

      var now = new Date();
      var from = addBusinessDays(now, procMin);
      from.setDate(from.getDate() + shipMin);
      var to = addBusinessDays(now, procMax);
      to.setDate(to.getDate() + shipMax);

      var locale = document.documentElement.lang || 'en';
      var fmt;
      try {
        fmt = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' });
      } catch (e) {
        fmt = new Intl.DateTimeFormat('en', { month: 'short', day: 'numeric' });
      }
      out.textContent = fmt.format(from) + ' – ' + fmt.format(to);
      el.removeAttribute('hidden');
    });
  }

  /* --------------------------------------------------------- sticky cta bar - */
  function setupSticky(scope) {
    scope.querySelectorAll('[data-r-sticky]:not([data-r-sticky-ready])').forEach(function (bar) {
      bar.setAttribute('data-r-sticky-ready', '');
      var triggerSelector = bar.getAttribute('data-r-sticky');
      var trigger = triggerSelector ? document.querySelector(triggerSelector) : null;
      if (!trigger || !('IntersectionObserver' in window)) return;

      var footer = document.querySelector('footer');
      var triggerPassed = false;
      var footerVisible = false;

      function apply() {
        bar.classList.toggle('r-sticky--on', triggerPassed && !footerVisible);
      }

      new IntersectionObserver(
        function (entries) {
          triggerPassed = entries[0].boundingClientRect.top < 0 && !entries[0].isIntersecting;
          apply();
        },
        { threshold: 0 }
      ).observe(trigger);

      if (footer) {
        new IntersectionObserver(
          function (entries) {
            footerVisible = entries[0].isIntersecting;
            apply();
          },
          { threshold: 0 }
        ).observe(footer);
      }
    });
  }

  /* ------------------------------------------------- offer cards → the cart - */
  function setupOfferCards(scope) {
    scope.querySelectorAll('[data-r-pack]:not([data-r-pack-ready])').forEach(function (card) {
      card.setAttribute('data-r-pack-ready', '');
      var idInput = card.querySelector('input[name="id"]');

      card.addEventListener('change', function (event) {
        var option = event.target.closest('[data-r-variant]');
        if (!option || !idInput) return;
        idInput.value = option.getAttribute('data-r-variant');
        var price = card.querySelector('[data-r-pack-price]');
        if (price && option.getAttribute('data-r-price')) price.textContent = option.getAttribute('data-r-price');
      });

      var form = card.querySelector('form[data-r-atc]');
      if (!form) return;

      form.addEventListener('submit', function (event) {
        var actions = window.Shopify && window.Shopify.actions;
        if (!actions || !actions.updateCart || !idInput || !idInput.value) return; // native POST fallback
        event.preventDefault();

        var button = form.querySelector('button[type="submit"]');
        var label = button ? button.textContent : '';
        if (button) {
          button.disabled = true;
          button.textContent = button.getAttribute('data-adding-text') || 'Adding…';
        }

        actions
          .updateCart({ lines: [{ merchandiseId: idInput.value, quantity: 1 }] }, { event: { context: 'product' } })
          .then(function () {
            if (actions.openCart) return actions.openCart();
          })
          .catch(function () {
            form.submit();
          })
          .finally(function () {
            if (button) {
              button.disabled = false;
              button.textContent = label;
            }
          });
      });
    });
  }

  /* ------------------------------------------- bundle cards (product page) -- */
  function setupBundles(scope) {
    scope.querySelectorAll('.r-bundles:not([data-r-bundles-ready])').forEach(function (picker) {
      picker.setAttribute('data-r-bundles-ready', '');
      var sync = function () {
        picker.querySelectorAll('.r-bundle').forEach(function (card) {
          var input = card.querySelector('input[type="radio"]');
          card.classList.toggle('r-bundle--on', !!(input && input.checked));
        });
      };
      picker.addEventListener('change', sync);
      sync();
    });
  }

  /* ------------------------------------------------------------------ init - */
  function init(scope) {
    var target = scope || document;
    setupReveal(target);
    setupProgress(target);
    setupFaq(target);
    setupDelivery(target);
    setupSticky(target);
    setupOfferCards(target);
    setupBundles(target);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Theme editor: new/edited sections arrive after load. */
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:select', function (event) {
    event.target.querySelectorAll('[data-r]').forEach(function (el) { el.classList.add('r-in'); });
  });
  document.addEventListener('shopify:block:select', function (event) {
    var section = event.target.closest('.shopify-section') || event.target;
    section.querySelectorAll('[data-r]').forEach(function (el) { el.classList.add('r-in'); });
  });

  /* Variant changes re-render parts of the product page: re-scan afterwards. */
  document.addEventListener('shopify:product:select', function () {
    window.setTimeout(function () { init(); }, 60);
  });

  root.classList.add('rollo-js');
})();